var exports = {
  "k": "x93eb46d8--d95e3e--container",
  "K": "x93eb46d8--d95e3e--icon",
};

module.exports = exports;
